import { render, staticRenderFns } from "./Proposals.vue?vue&type=template&id=be4fdb92"
import script from "./Proposals.vue?vue&type=script&lang=js"
export * from "./Proposals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports